export default class ThemeSwitcher {
    static init(): void {
        // Funkce pro získání aktuálního tématu
        function getCurrentTheme(): string {
            const storedTheme = localStorage.getItem('theme');
            if (storedTheme) {
                return storedTheme;
            }
            return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        }

        // Funkce pro nastavení tématu a synchronizaci tlačítek
        function setTheme(theme: string): void {
            document.documentElement.setAttribute('data-theme', theme);
            localStorage.setItem('theme', theme);

            // Synchronizace všech tlačítek
            const themeToggleButtons = document.querySelectorAll('.base-navbar-switch');
            themeToggleButtons.forEach((button) => {
                if (theme === 'dark') {
                    button.classList.add('is-active');
                } else {
                    button.classList.remove('is-active');
                }
            });
        }

        // Inicializace aktuálního tématu při načtení stránky
        const currentTheme: string = getCurrentTheme();
        setTheme(currentTheme);

        // Přidání event listenerů na všechna tlačítka
        const themeToggleButtons = document.querySelectorAll('.base-navbar-switch');
        themeToggleButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault(); // Zamezí navigaci (protože je to <a>)
                const currentTheme = document.documentElement.getAttribute('data-theme');
                const newTheme = currentTheme === 'light' ? 'dark' : 'light';
                setTheme(newTheme);
            });
        });
    }
}
